import React, { useContext, useEffect, useState } from "react"
import Sentry from "./Common/Sentry"
import { RequestHandler } from "./Utils/request_handler"

import Header from "./Common/Shelters/Header"
import ResultSet from "./ShelterArea/ResultSet"
import Title from "./ShelterArea/Title"
import Footer from "./Common/Footer"
import { GeolocationHandler } from "./Utils/geolocation_handler"
import { PCViewContext } from "./Common/PCViewContext"
const geoHandler = new GeolocationHandler()

import * as commonStyles from "./Common/Styles/ListContainer.module.scss"
import classNames from "classnames/bind"
import { Shelter, ShelterArea } from "./types/shelter"

const fetchCoords = async () => {
  try {
    const coords = await geoHandler.getPosition()
    return [coords.latitude, coords.longitude]
  } catch (e) {
    console.log(e)
  }
  return [null, null]
}

const fetchShelters = async (areaId: number) => {
  const [lat, lon] = await fetchCoords()
  try {
    const handler = new RequestHandler(
      `/shelter_areas/${areaId}/shelters?latitude=${lat}&longitude=${lon}`,
      "GET"
    )
    const res = await handler.requestWithBody()
    if (res.status === 200) {
      return res.body
    }
  } catch (e) {
    Sentry.captureException(e)
    return []
  }
}

const Area: React.FC<{
  area: ShelterArea
  lastUpdatedAt: string
  count: number
}> = ({ area, lastUpdatedAt, count }) => {
  const [shelters, setShelters] = useState([])
  const [showLoader, setShowLoader] = useState(true)
  const isPC = useContext(PCViewContext)

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        setShelters(await fetchShelters(area.id))
        setShowLoader(false)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [])

  return (
    <React.Fragment>
      <Header logo={area.logo} />
      <div className={commonStyles.container}>
        <div className={classNames(isPC ? commonStyles.inner : "")}>
          <Title name={area.name} lastUpdatedAt={lastUpdatedAt} />
          <ResultSet
            count={count}
            shelters={shelters as Array<Shelter>}
            showLoader={showLoader}
            url={area.url}
          />
        </div>
      </div>
      <Footer />
    </React.Fragment>
  )
}
export default Area
